import { AnalysisStatus } from "@explorance/mly-types";

export const isAnalyzed = (status: AnalysisStatus) => status === AnalysisStatus.Completed;
